import React from 'react'
import PropTypes from 'prop-types'

function Tag({name, color, contrastingTextColor, variant}) {
  variant = variant || Tag.defaultVariant

  const style = {}

  switch (variant) {
    case 'outline':
      style.borderColor = color
      break
    case 'entwurf':
      break
    default:
      style.backgroundColor = color
      if (contrastingTextColor) {
        style.color = contrastingTextColor
      }
      break
  }

  const classNames = ['tag', `tag--${variant}`].join(' ')

  return (
    <div className={classNames} style={style}>
      {name}
    </div>
  )
}

Tag.defaultVariant = 'fill'

Tag.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  contrastingTextColor: PropTypes.string,
  variant: PropTypes.oneOf(['fill', 'outline', 'entwurf']),
}

export default Tag
